<template>
  <text-input
    :id="id"
    ref="input"
    v-model="localValue"
    class="currency-input"
    type="decimal"
    :symbol="currencySymbol"
    :label="label"
    :required="required"
    :disabled="disabled"
  >
    <slot />
  </text-input>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: Number,
    id: String,
    label: String,
    required: Boolean,
    disabled: Boolean,
  },

  data() {
    return {
      localValue: 0,
    };
  },

  mounted() {
    this.localValue = this.convertToCurrency(this.value);
  },

  watch: {
    value(value) {
      this.localValue = this.convertToCurrency(value);
    },

    localValue(value) {
      this.$emit('input', this.convertToUsd(value));
    },
  },

  computed: {
    ...mapGetters({
      currencyRatio: 'currencyRatio',
      currencySymbol: 'currencySymbol',
    }),
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },

    convertToCurrency(value) {
      if (Number.isNaN(value)) {
        return 0;
      }

      return Number(Number(value * this.currencyRatio).toFixed(2));
    },

    convertToUsd(value) {
      return Number(Number(value / this.currencyRatio).toFixed(this.currencyRatio === 1 ? 2 : 3));
    },
  },
};
</script>
